import styled from '@emotion/styled';
import { themed, ITheme } from '../../themer';

export const ImageWrap = styled.span<{}, ITheme>`
	display: block;

	img {
		background: ${themed(({ background }) => background.light)};
	}
`;
